const extractPropertyKey = (key) => key.split('[')[1].split(']')[0]

const createBaseProperties = () => ({
	'_Accepts M2O Terms': 'Yes', // Accepted terms
})

const extractFormProperties = (formData) => {
	const properties = {}

	formData.forEach((value, key) => {
		if (key.startsWith('properties')) {
			const propKey = extractPropertyKey(key)
			properties[propKey] = value
		}
	})

	return properties
}

const getMainItems = (formData, properties) => {
	const items = []
	// If items to add are set, add them to the list
	if (
		window.Made2Order?.itemsToAdd &&
		window.Made2Order.itemsToAdd.length > 0
	) {
		window.Made2Order.itemsToAdd
			.filter((item) => !item.properties?.['_for'])
			.forEach((item) => {
				items.push({
					id: item.id,
					quantity: item.quantity || 1,
					properties: {
						...item.properties,
						...properties,
					},
				})
			})
	}
	if (items.length === 0) {
		items.push({
			id: formData.get('id'),
			quantity: 1,
			properties: properties,
		})
	}
	return items
}

const getAddons = () => {
	const addons = []
	// If additional items to add are set, add them to the list
	if (
		window.Made2Order?.additionalItemsToAdd &&
		window.Made2Order.additionalItemsToAdd.length > 0
	) {
		window.Made2Order.additionalItemsToAdd.forEach((item) => {
			addons.push({
				id: item.id,
				quantity: item.quantity || 1,
				properties: {
					...item.properties
				},
			})
		})
	}
	return addons
}

const registerMadeToOrder = () => {
	document.addEventListener('cc:modal:open', (event) => {
		const modal = event.detail.modal
		if (!modal) return
		const confirmationModal = modal.querySelector(
			'.product-confirmation-modal'
		)
		if (!confirmationModal) return

		const type = confirmationModal.dataset.productConfirmationModal

		const submitButton = confirmationModal.querySelector(
			'button[type="submit"]'
		)

		const options = confirmationModal.querySelectorAll(
			'.custom-option__text-input'
		)

		const confirmationInput = confirmationModal.querySelector(
			'.confirmation-input input'
		)

		// Fix confirmation input not working because of duplicated input id's
		const confirmationInputContainer = confirmationModal.querySelector(
			'.confirmation-input'
		)

		options.forEach((option) => {
			const sourceId = option.id.replace(/-confirmation.*/, '')
			const sourceOption = document.getElementById(sourceId)
			if (sourceOption) {
				option.value = sourceOption.value
			}
		})

		// Check that terms are accepted and note is filled
		submitButton.addEventListener('click', async (e) => {
			e.preventDefault()
			e.stopPropagation()
			let isValid = true
			submitButton.classList.add('disabled')
			// clear errors
			options.forEach((option) => {
				option.classList.remove('error')
			})
			confirmationInputContainer.classList.remove('error')

			if (!confirmationInput.checked) {
				console.error('Confirmation input required')
				confirmationInputContainer.classList.add('error')
				isValid = false
			}

			if (isValid) {
				// Grab all values from form and submit using fetch
				const formData = new FormData(submitButton.form)

				const properties = {
					...createBaseProperties(),
					...extractFormProperties(formData),
				}

				const mainItems = getMainItems(formData, properties)
				const addons = getAddons(properties._id)
				
				const html = submitButton.innerHTML
				submitButton.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>' 

				// Add items to cart
				const response = await fetch(`${window.routes.cartUrl}/add.js`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({
						items: [
							...mainItems,
							...addons,
						],
					}),
				})


				// Navigate to checkout
				if (submitButton.hasAttribute('data-direct-to-checkout')) {
					window.location.href = '/checkout'
				} else {
					document
						.querySelectorAll('.cc-modal-window__close')
						.forEach((closeButton) => {
							closeButton.click()
						})
					window.theme.addedToCartHandler(response)
				}
				
				submitButton.innerHTML = html

				if (window.Made2Order?.debug) {
					alert(
						`M2O: Items added: ${JSON.stringify(
							[...mainItems, ...addons],
							null,
							2
						)}`
					)
				}
			}
			submitButton.classList.remove('disabled')
		})
	})

	// Listen to click on "add as gift" button
	document.addEventListener('click', (event) => {
		if (event.target.closest('[data-made-to-order-gift]')) {
			const giftButton = event.target.closest('[data-made-to-order-gift]')
			const variantTitle = giftButton.dataset.variantTitle
			const giftVariantId = giftButton.dataset.madeToOrderGift

			if (!giftVariantId) {
				console.error('No gift variant id found')
				return
			}

			const giftItem = {
				id: giftVariantId,
				quantity: 1,
				properties: {
					_for: variantTitle
				}
			}

			const additionalItemsToAdd =
				window.Made2Order?.additionalItemsToAdd || []

			// Create the items to add list
			window.Made2Order = {
				additionalItemsToAdd: additionalItemsToAdd.concat([giftItem]),
			}

			// Close modal
			const modal = event.target.closest('.cc-modal-window')
			const closeButton = modal.querySelector('.cc-modal-window__close')
			closeButton.click()

			// Click main order button
			const mainBuyButton = document.querySelector(
				'.buy-buttons-row button'
			)
			mainBuyButton.click()
		}
	})

	// Reset Made2Order when variant is updated
	window.addEventListener('cc:variant-updated', (event) => {
		window.Made2Order = undefined
	})
}

registerMadeToOrder()